import { createFileRoute } from '@tanstack/react-router';

import {
  AddLocationKeywords,
  addLocationKeywordsSearchSchema
} from 'features/locations/AddLocation/AddLocationKeywords';

export const Route = createFileRoute('/_authenticated/locations/add/keywords/')({
  component: AddLocationKeywordsRoute,
  validateSearch: addLocationKeywordsSearchSchema
});

function AddLocationKeywordsRoute() {
  const { locationId, placeId } = Route.useSearch();

  return <AddLocationKeywords locationId={locationId} placeId={placeId} />;
}
